import { useState } from 'react'

import { useMutation } from '@tanstack/react-query'
import { getRouteApi, useRouter } from '@tanstack/react-router'
import { Request } from 'commons/utils/request/request'
import { IconName, Toast } from 'ui/components'
import { ButtonGroup } from 'ui/components/ButtonGroup'
import { Button, IconButton } from 'ui/components/Buttons'
import { Tooltip } from 'ui/components/Tooltip'
import { Footer as FooterWrapper } from 'ui/temp/Footer'
import { AdverseMediaDetailsType } from '~bank-adverse-media/types/details'

import { useSelectionPublicationContext } from '../../context/SelectionPublicationContext'
import { SetRiskLevelDialog } from './components/SetRiskLevelDialog'

import { s } from './styles'

export const Footer = () => {
  const router = useRouter()
  const routeApi = getRouteApi('/_app/adverse-media/$id')
  const loaderData = routeApi.useLoaderData({ select: (s) => s }) as AdverseMediaDetailsType
  const { hasSelectedItems, selectAll, deleteAllUnreviewed, selectedIds, isAllSelected, clearSelection } =
    useSelectionPublicationContext()
  const isSomePublicationNeedsReview = loaderData.alertedPublicationsCount > 0
  const [isSetRiskLevelDialogOpen, setIsSetRiskLevelDialogOpen] = useState(false)

  const { mutate: reviewPublication } = useMutation<void, Error, { ids: number[] }>({
    mutationFn: (opts) => Request.patch(Request.urls.bank.adverseMediaPublicationReview, opts),
    onSuccess: () => {
      router.invalidate()
      clearSelection()
    },
    onError: (e) => {
      Toast.errorSmall(e.message)
    }
  })

  const onMarkSelectedAsReviewed = () => {
    reviewPublication({ ids: selectedIds })
  }

  return (
    <>
      {isSetRiskLevelDialogOpen && <SetRiskLevelDialog onClose={() => setIsSetRiskLevelDialogOpen(false)} />}
      <FooterWrapper
        childrenLeftSide={
          <>
            {isSomePublicationNeedsReview && (
              <s.WrappedCheckBox value={isAllSelected} onChange={() => selectAll()} checkBoxLabel="Select All" />
            )}
            {hasSelectedItems && (
              <IconButton onClick={onMarkSelectedAsReviewed} face="positive" icon={IconName.CHECK_WHITE}>
                Review Selected
              </IconButton>
            )}
          </>
        }
        children={
          <>
            {isSomePublicationNeedsReview ? (
              <ButtonGroup margin="big">
                <IconButton onClick={deleteAllUnreviewed} face="negative" icon={IconName.DELETE}>
                  Delete All Unreviewed
                </IconButton>
                <Tooltip id="risk-level-btn-tip" type="dark" content="You have unreviewed news" event="hover">
                  <Button face="primary" onClick={() => {}} disabled>
                    Set Risk Level
                  </Button>
                </Tooltip>
              </ButtonGroup>
            ) : (
              <Button face="primary" onClick={() => setIsSetRiskLevelDialogOpen(true)} data-qa="set-risk-level">
                Set Risk Level
              </Button>
            )}
          </>
        }
      />
    </>
  )
}
